import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

import { SubscriptionHelperService } from '../../../../../utils/services/src/lib/subscription-helper.service';

@Component({
  selector: 'offconon-subscription-upgrade-dialog',
  imports: [CommonModule, DialogModule, TranslateModule, ButtonModule],
  templateUrl: './subscription-upgrade-dialog.component.html',
  styles: ``,
})
export class SubscriptionUpgradeDialogComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }
  private destroyRef = inject(DestroyRef);

  private subscriptionHelperService = inject(SubscriptionHelperService);
  private router = inject(Router);
  private translateService = inject(TranslateService);

  premiumVisible = false;
  dialog_data: any;
  close_redirect: any;

  dialog_title: any;

  dialog_main_title: any;
  dialog_main_desc: any;

  subscription_link: any;

  ngOnInit() {
    this.subscriptionHelperService.premiumDialogData$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (postData: any) => {
          if (postData) {
            this.dialog_data = postData;

            if (this.dialog_data?.subscription_type === 'user') {
              this.subscription_link = '/personal-subscription';
            } else if (this.dialog_data?.subscription_type === 'business') {
              this.subscription_link = '/premium-subscription';
            }

            switch (this.dialog_data?.dialog_type) {
              case 'limit_reach':
                this.dialog_title = this.translateService.instant('Subscription limit reached');
                this.dialog_main_title = null;
                this.dialog_main_desc = this.translateService.instant(
                  "It looks like you've hit the limit for your current subscription plan. Upgrade now to continue enjoying uninterrupted access and unlock even more features!",
                );
                break;

              case 'free_reach':
                this.dialog_title = this.translateService.instant('Free Limit Reached');
                this.dialog_main_title = null;
                this.dialog_main_desc = this.translateService.instant(
                  "You've reached the limit of your free plan. Upgrade now to keep enjoying full access and unlock premium features!",
                );
                break;
            }

            if (this.dialog_data?.redirect_link) {
              this.close_redirect = this.dialog_data?.redirect_link;
            } else {
              this.close_redirect = null;
            }

            this.showDescription();
            this.subscriptionHelperService.setpremiumDialogData(null);
          }
        },
      });
  }

  showDescription() {
    this.premiumVisible = true;
  }

  closeDialog() {
    this.premiumVisible = false;
    this.dialog_data = null;
    if (this.close_redirect) {
      this.router.navigate([this.close_redirect]);
    }
  }

  openPremium() {
    this.premiumVisible = false;
    this.dialog_data = null;

    setTimeout(() => {
      this.router.navigate([this.subscription_link]);
    }, 500);
  }
}
